import { useLocation } from 'js/lib/useRouter';

const useSimplifiedNav = () => {
  const paths = [
    /^\/$/,
    /^\/frontpage/,
    /^\/my-learning/,
    /^\/programs.*/,
    /^\/degrees.*/,
    /^\/career-academy.*/,
    /^\/learn\/[^/]*$/,
    /^\/projects.*/,
    /^\/specializations.*/,
    /^\/lecture.*/,
    /^\/search.*/,
    /^\/courses.*/,
    /^\/browse.*/,
    /^\/courseraplus.*/,
    /^\/professional-certificates.*/,
    /^\/articles.*/,
    /^\/mastertrack.*/,
    /^\/about.*/,
    /^\/directory.*/,
    /^\/account-settings.*/,
    /^\/account-profile.*/,
    /^\/my-purchases.*/,
    /^\/profile.*/,
    /^\/updates.*/,
    /^\/accomplishments.*/,
    /^\/purchase.*/,
    /^\/payments.*/,
    /^\/my-learning.*/,
    /^\/login.*/,
    /^\/signup.*/,
    /^\/certificates.*/,
    /^\/en-IN/,
  ];
  const location = useLocation();
  const isValidPath = paths.some((pathRegex) => location.pathname.match(pathRegex));

  return isValidPath;
};

export default useSimplifiedNav;
